var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-head-actions"},[_c('div',{staticClass:"actions-sub"},[_vm._t("sub")],2),_vm._v(" "),_c('div',{staticClass:"actions-main"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }